import { FileCheck2, Scale, ShieldCheck } from 'lucide-react';
import { Link, useParams } from 'react-router-dom';
import { PageHero } from '../components/Sections';
import { legalDocuments, policyMeta } from '../legalContent';
import { NotFound } from './NotFound';

export function LegalPage({ documentKey }) {
  const { slug } = useParams();
  const key = documentKey || slug;
  const document = legalDocuments[key];

  if (!document) return <NotFound />;

  return (
    <>
      <PageHero eyebrow="Sawwari legal" title={document.title} text={document.summary} tone="light" />
      <section className="section legal-page">
        <div className="container legal-layout">
          <aside>
            <FileCheck2 />
            <strong>Policy version {policyMeta.version}</strong>
            <p>Effective {policyMeta.effectiveDate}</p>
            <dl className="policy-facts">
              <div><dt>Operator</dt><dd>{policyMeta.operator}</dd></div>
              <div><dt>Territory</dt><dd>Pakistan</dd></div>
              <div><dt>Contact</dt><dd><a href={`mailto:${policyMeta.contact}`}>{policyMeta.contact}</a></dd></div>
            </dl>
            <Link className="text-link" to="/legal">All legal documents</Link>
          </aside>
          <article>
            <div className="legal-priority-note" role="note">
              <Scale aria-hidden="true" />
              <p>This policy applies alongside mandatory Pakistani law and locally applicable transport and consumer rules. If a term conflicts with a right that cannot lawfully be excluded, the mandatory rule prevails.</p>
            </div>
            {document.sections.map((section) => (
              <section className="legal-section" key={section.title}>
                <h2>{section.title}</h2>
                {section.paragraphs?.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
                {section.bullets && (
                  <ul>{section.bullets.map((bullet) => <li key={bullet}>{bullet}</li>)}</ul>
                )}
              </section>
            ))}
            <div className="legal-contact-card">
              <ShieldCheck aria-hidden="true" />
              <div><strong>Questions or complaints</strong><p>Email <a href={`mailto:${policyMeta.contact}`}>{policyMeta.contact}</a> or use the <Link to="/support">Sawwari support path</Link>. For immediate danger in Pakistan, call 15.</p></div>
            </div>
          </article>
        </div>
      </section>
    </>
  );
}
